var ExceptionHandler = /** @class */ (function () {
    function ExceptionHandler(response) {
        this.exception = this._initializeException(response);
    }
    ExceptionHandler.prototype._initializeException = function (response) {
        var exception = {
            status: response.status,
            statusText: response.statusText,
            code: response.body.code ? response.body.code : 'No error code provided.',
            message: response.body.message ? response.body.message : 'No message provided.'
        };
        return exception;
    };
    return ExceptionHandler;
}());
export { ExceptionHandler };
//# sourceMappingURL=http-exception.js.map